<template>
  <div>
    <div class="analysisItem">
      <div class="title">测评说明</div>
      <div class="text-theme-black-850" v-html="instruction"></div>
    </div>
    <div class="analysisItem">
      <div class="title">测评结果</div>
      <div class="text-theme-black-850" v-html="answerDimensionScore.suggestion"></div>
    </div>
    <div class="analysisItem flex justify-between items-center">
      <div class="title">得分分析</div>
      <el-select size="small" v-model="chartType">
        <el-option v-for="item in chartTypes" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
    </div>
    <analysis-chart :type="chartType" :source="chartSource" />
    <div class="analysisItem">
      <div class="title">维度分析</div>
      <div v-for="item in answerDimensionScore.details" class="dimensionAnalysis">
        <div class="leading-22 text-theme-black-850">{{ item.title }}</div>
        <div class="score">
          <span
            >得分：{{
              openStandardScore ? `${item.score} / 标准分：${item.standardScore === null ? 0 : item.standardScore}` : item.score
            }}</span
          >
        </div>
        <div class="text-small text-theme-black-650" v-html="item.suggestion"></div>
      </div>
      <!--      <div class="text-center mt-2" v-if="dimensionList.length === 3 && answerDimensionScore.details.length > 3">-->
      <!--        <el-button type="text" size="mini" @click="getMore">查看更多</el-button>-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
import { busGetters } from 'dygc'
import { chartTypeCode, chartTypes } from '@/components/end/chartType'
import AnalysisChart from '@/components/end/AnalysisChart'
export default {
  name: 'AnswerAnalysis',
  components: {
    AnalysisChart
  },
  data() {
    return {
      instruction: '',
      // dimensionList: [],
      chartTypes,
      chartType: chartTypeCode.LEIDA
    }
  },
  methods: {
    // getMore() {
    //   this.dimensionList = this.answerDimensionScore.details
    // }
  },
  computed: {
    ...busGetters(['answerDimensionScore', 'openStandardScore']),
    chartSource() {
      return this.answerDimensionScore.details
    }
  },
  mounted() {
    if (this.answerDimensionScore.instruction && this.answerDimensionScore.instruction[0] === '{') {
      this.instruction = JSON.parse(this.answerDimensionScore.instruction).instruction
    } else {
      this.instruction = this.answerDimensionScore.instruction
    }
    //展开更多
    // if (this.answerDimensionScore.details.length > 3) {
    //   this.dimensionList = this.answerDimensionScore.details.slice(0, 3)
    // } else {
    //   this.dimensionList = this.answerDimensionScore.details
    // }
  }
}
</script>

<style lang="scss" scoped>
.analysisItem {
  @apply mt-6;
  .title {
    @apply font-medium leading-22 mb-2 text-theme-black-850;
  }
  .score {
    margin-top: 2px;
    margin-bottom: 6px;
    @apply text-theme-black-650;
    span {
      @apply text-small rounded-small bg-card-bg-gray p-1;
    }
  }
  .dimensionAnalysis {
    @apply pb-3 border-b border-black border-solid border-opacity-5 rounded-medium;
  }
}
</style>
